import React from "react";
import PropTypes from "prop-types";
import { Container } from "reactstrap";
import styles from "./SyncProgressCard.module.css";

import { formatLocalDateTime } from "../../../../../utils/formatDate";

const SyncProgressCard = ({ overview }) => {
    if (!overview) return null;

    return (
        <Container fluid>
            <div className={styles.card}>
                <h3 className={styles.title}>
                    Procesos ERP
                </h3>
                <div className={styles.syncInfo}>
                    <div>Última sincronización: {formatLocalDateTime(overview.sync.last_sync_finished_at)}</div>
                    <div>Iniciada en: {formatLocalDateTime(overview.sync.last_sync_started_at)}</div>
                    <div>Última extracción: {formatLocalDateTime(overview.metadata.last_extraction)}</div>
                </div>
            </div>
        </Container>
    );
};

SyncProgressCard.propTypes = {
    overview: PropTypes.shape({
        sync: PropTypes.shape({
            progress: PropTypes.number.isRequired,
            last_sync_finished_at: PropTypes.string.isRequired,
            last_sync_started_at: PropTypes.string.isRequired,
        }).isRequired,
        metadata: PropTypes.shape({
            last_extraction: PropTypes.string.isRequired,
        }).isRequired,
    }),
};

SyncProgressCard.defaultProps = {
    overview: null,
};

export default SyncProgressCard;
